import validate from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/middleware/auth.js")
}